import { CartContext } from '../../contexts/cart.context';
import { useContext } from 'react';
import CheckoutCard from '../../components/checkout-card/checkout-card.component';
import {CheckoutContainer, CheckoutHeader, HeaderBlock, Total} from './checkout.styles.jsx';

const Checkout = () => {
    const { cartItems, allItemsTotal } = useContext(CartContext);
    
    return (
        <CheckoutContainer>
            <CheckoutHeader>
                <HeaderBlock>
                    <span>Product</span>
                </HeaderBlock>
                <HeaderBlock>
                    <span>Description</span>
                </HeaderBlock>
                <HeaderBlock>
                    <span>Quantity</span>
                </HeaderBlock>
                <HeaderBlock>
                    <span>Price</span>
                </HeaderBlock>
                <HeaderBlock>
                    <span>Remove</span>
                </HeaderBlock>
            </CheckoutHeader>
                {cartItems.map((product) => (
                    <CheckoutCard key={product.id} product={product}/>
                ))}
            <Total>total: ${allItemsTotal} </Total>
        </CheckoutContainer>
    )
};

export default Checkout;
